import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import LuxeHeader from "@/components/luxe/LuxeHeader";
import LuxeFooter from "@/components/luxe/LuxeFooter";

export default function LuxeLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="luxe min-h-screen flex flex-col" data-testid="luxe-layout">
      <LuxeHeader />
      <main className="flex-1 pt-24" data-testid="luxe-main">
        <Outlet />
      </main>
      <LuxeFooter />
    </div>
  );
}
